import React, { useCallback, useState, useEffect } from 'react';
import { Box, Typography, Chip } from '@mui/material';
import Inputs from './Inputs';

const interestsOptions = [
    'Agricoltura', 'Arte', 'Avventura', 'Benessere', 'Business', 'Carriere', 'Cinema', 'Convivial', 'Consulenza', 'Crescita personale', 'Creatività', 'Musica', 'Cultura', 'Design', 'Economia', 'Educazione', 'Energia alternativa', 'Esplorazione spaziale', 'Finanza', 'Fitness', 'Fotografia', 'Futuro', 'Gaming', 'Gestione del tempo', 'Innovazione', 'Investimenti', 'Leadership', 'Marketing', 'Management', 'Media digitali', 'Mercati', 'Moda', 'Motivazione', 'Natura', 'Networking', 'Noleggio auto', 'Partnership', 'Produttività', 'Relazioni con i clienti', 'Salute', 'Scienza', 'Social media', 'Social network', 'Solidarietà', 'Sport', 'Startup', 'Stile di vita', 'Storytelling', 'Strategia', 'Successo', 'Sostenibilità', 'Tecnologia', 'Teatro', 'Viaggi', 'Venture capital',
];

const formattedInterestsOptions = interestsOptions.map(interest => ({
    value: interest,
    label: interest,
}));

const InterestsSelection = ({ viewState, userInterests = ['Convivial'], setUserInterests, selectOption = false }) => {
    const [selectedInterests, setSelectedInterests] = useState(userInterests || []);

    // Ensure "Convivial" is always included in Chip section, but not in select mode
    const ensureConvivialInChip = useCallback((interests) => {
        if (selectOption) {
            return interests; // No need to force Convivial inclusion in select mode
        }
        if (!interests.includes('Convivial')) {
            return [...interests, 'Convivial']; // Add "Convivial" if not present
        }
        return interests;
    }, [selectOption]);

    // Handle multiple selection of interests
    const handleToggleInterest = (interest) => {
        setSelectedInterests((prevSelected) => {
            const newSelected = prevSelected.includes(interest)
                ? prevSelected.filter(item => item !== interest) // Remove interest
                : [...prevSelected, interest]; // Add interest

            const updatedInterests = ensureConvivialInChip(newSelected); // Ensure "Convivial" remains in Chip
            setUserInterests(updatedInterests); // Update user interests after changing the state
            return updatedInterests; // Return the new state
        });
    };

    // Handle single interest selection
    const handleSetSingleInterest = (interest) => {
        const newSelected = [interest];
        const updatedInterests = ensureConvivialInChip(newSelected); // Ensure "Convivial" is not removed in Chip
        setSelectedInterests(updatedInterests);
        setUserInterests(updatedInterests);
    };

    useEffect(() => {
        // Update selected interests when userInterests prop changes
        const updatedInterests = ensureConvivialInChip(userInterests);
        setSelectedInterests(updatedInterests);
    }, [ensureConvivialInChip, userInterests]);

    return (
        <>
            {selectOption
                ? (
                    <Box mt={2}>
                        <Inputs
                            mt={0}
                            type="select"
                            label="Interesse a parlare di"
                            value={userInterests[0]}
                            onChange={(e) => handleSetSingleInterest(e.target.value)}
                            possibilities={formattedInterestsOptions}
                            required
                        />
                    </Box>
                )
                : (
                    <Box >
                        {viewState === 'edit' && (
                            <>
                                <Box >
                                    {interestsOptions.map((interest) => (
                                        <Chip
                                            key={interest}
                                            label={interest}
                                            onClick={() => handleToggleInterest(interest)}
                                            variant={selectedInterests.includes(interest) ? 'filled' : 'outlined'}
                                            color={selectedInterests.includes(interest) ? 'primary' : 'default'}
                                            sx={{ margin: '3px' }}
                                        />
                                    ))}
                                </Box>
                            </>
                        )}
                        {viewState !== 'edit' && userInterests && (
                            <>
                                <Typography variant="subtitle1" color="textPrimary">
                                    Interessi
                                </Typography>
                                <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
                                    {selectedInterests.join(', ')}
                                </Typography>
                            </>
                        )}
                    </Box>
                )
            }
        </>
    );
};

export default InterestsSelection;
